<div class="m-quiz-paused">
  <h3>
    This quiz is paused!
  </h3>
  <div class="row">
    <div class="col-12">Be patient!</div>
  </div>
</div>